
//Représente les paramètres de mise à jour du filtre des colonnes d’un utilisateur
export class ASeMettreAJourFiltreColonnesUtilisateurParametres 
{
  //Création
  constructor () 
  {
    this.filtreColonnes = [];
  }

  //Identifiant de l’onglet
  public identifiantOnglet!: string;

  //Filtre des colonnes
  public filtreColonnes: ASeFiltreColonne[];
}

//Représente le filtre d’une colonne
export class ASeFiltreColonne 
{
  //Création
  constructor () 
  {
    this.valeurFiltreTexte = null;
    this.valeurFiltreInt = null;
    this.valeurFiltreDate = null;
    this.valeurFiltreDecimal = null;
    this.valeurFiltreBoolean = null;
    this.operateurFiltre = null;
  }

  //Identifiant de la colonne
  public identifiant!: string;

  //Valeur du filtre texte
  public valeurFiltreTexte: string | null;

  //Valeur du filtre int
  public valeurFiltreInt: number | null;

  //Valeur du filtre date
  public valeurFiltreDate: Date | null;

  //Valeur du filtre décimal
  public valeurFiltreDecimal: number | null;

  //Valeur du filtre boolean
  public valeurFiltreBoolean: boolean | null;

  //Opérateur du filtre
  public operateurFiltre: string | null;
}

//Représente le filtre d’une colonne tel qu’il est envoyé à l’API : la date au format yyyy-MM-dd
export type ASeFiltreColonneEnvoye = Omit<ASeFiltreColonne, "valeurFiltreDate"> & {valeurFiltreDate: string | null};

//Représente les paramètres de mise à jour du filtre des colonnes tels qu’ils sont envoyés à l’API
export type ASeMettreAJourFiltreColonnesUtilisateurCorps = Omit<ASeMettreAJourFiltreColonnesUtilisateurParametres, "filtreColonnes"> & {filtreColonnes: ASeFiltreColonneEnvoye[]};
